/*global SunergoPlatform*/

const inputEvents = SunergoPlatform.inputEvents;

/**
 * Password Checker strength validation for Password fields.
 * @param {object} form - the form item.
 * @returns early if no password fields found.
 */
const initPasswordChecker = function(form) {
	const passwordFields = form.element.querySelectorAll('[data-password]');
	if (!passwordFields || passwordFields.length < 1) return;

	const strength = {
		// Strong is at least 16 characters long with 1 uppercase, 1 lowercase, 1 number, 1 symbol
		strong: new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{16,})'),

		// Medium is at least 8 characters long with 1 uppercase, 1 lowercase, 1 number, 1 symbol
		// or 16 characters long with characters
		medium: new RegExp(
			'((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{10,}))' +
				'|((?=.*[A-za-z0-9])(?=.{16,}))'
		)
	};

	/**
	 * Check the strength of the password.
	 * @param {string} password - the password.
	 * @returns {integer} the strength of the password (0 being weakest, 3 being strongest).
	 */
	function strengthChecker(password) {
		if (strength.strong.test(password)) return 3;
		else if (strength.medium.test(password)) return 2;
		else if (password) return 1;
		else return 0;
	}

	/**
	 * Initializes the password checker.
	 * @param {HTMLElement} container - the password field container.
	 */
	function init(container) {
		const field = container.querySelector('[type="password"]');
		let timeout, prevStatus;

		// Find the password-visible toggle.
		const showPasswordToggle = container.querySelector('[data-action="show-password"]');
		if (showPasswordToggle) {
			showPasswordToggle.addEventListener('click', function() {
				// Add a listener to toggle the visibility of the password.
				if (showPasswordToggle.getAttribute('aria-checked') == 'true') field.type = 'text';
				else field.type = 'password';
			});
		}

		/**
		 * Check the password strength and show the status.
		 */
		function checkPassword() {
			let statusType = '';
			let msg = '';

			// Check the strength of the password.
			switch (strengthChecker(field.value)) {
				case 3:
					statusType = 'success';
					msg = container.dataset['i18nPasswordStrength-3'];
					break;

				case 2:
					statusType = 'warning';
					msg = container.dataset['i18nPasswordStrength-2'];
					break;

				case 1:
					statusType = 'error';
					msg = container.dataset['i18nPasswordStrength-1'];
					break;
			}

			// Clear previous status message if different.
			if (prevStatus != statusType) {
				form.fieldFeedback.set(field.name, statusType, msg);
				prevStatus = statusType;
			}
		}

		function checkPasswordWithTests(testCases) {
			for (var i = 0; i < testCases.length; i++) {
				var testCase = testCases[i];
				if (!field.value || field.value == '') {
					testCase.removeAttribute('data-is-valid');
					continue;
				}

				var isValid = false;

				if (testCase.dataset.testMinLength) if (field.value && field.value.length >= testCase.dataset.testMinLength) isValid = true;
				if (testCase.dataset.testMaxLength) if (field.value && field.value.length <= testCase.dataset.testMaxLength) isValid = true;

				if (testCase.dataset.testRegex) {
					var regexTest = new RegExp(decodeURI(testCase.dataset.testRegex));
					if (regexTest.test(field.value)) isValid = true;
				}

				testCase.dataset.isValid = isValid;
			}
		}

		const validateOption = container.dataset.password;
		if (validateOption == 'strength') {
			// Check if password field is strength-enabled
			for (let event in inputEvents) {
				field.addEventListener(inputEvents[event], function() {
					// Clear timeout and check password after .25 second (prevent spam).
					clearTimeout(timeout);
					timeout = setTimeout(checkPassword, 250);
				});
			}
		} else if (validateOption == 'match') {
			// Check if password field should check if it matches another field.
			const matchingFieldId = container.dataset.passwordMatch;
			const matchingField = form.element.querySelector(`[name="${matchingFieldId}"]`);

			for (let event in inputEvents) {
				field.addEventListener(inputEvents[event], function() {
					// Clear timeout and check for a match after .5 seconds.
					clearTimeout(timeout);
					timeout = setTimeout(function() {
						let statusType = '',
							msg = '';

						if (field.value == matchingField.value) {
							statusType = 'success';
							msg = container.dataset['i18nPasswordMatch'];
						} else if (matchingField.value && field.value) {
							// Only show error if both fields have values.
							statusType = 'error';
							msg = container.dataset['i18nPasswordMismatch'];
						}

						if (prevStatus != statusType) {
							form.fieldFeedback.set(field.name, statusType, msg);
							prevStatus = statusType;
						}
					}, 500);
				});
			}
		} else if (validateOption == 'tests') {
			var testCases = document.querySelector(`[data-password-validator-tests="${field.name}"]`);
			for (let event in inputEvents) {
				field.addEventListener(inputEvents[event], function() {
					// Clear timeout and check password after .25 second (prevent spam).
					clearTimeout(timeout);
					timeout = setTimeout(function() {
						checkPasswordWithTests(testCases.children);
					}, 250);
				});
			}
		}

		// Caps Lock Detection.
		if (field.dataset.capsLockWarn) {
			field.addEventListener('keyup', function(event) {
				const capsLockOn = event.getModifierState('CapsLock');
				if (capsLockOn) form.fieldFeedback.set(field.name, 'warning', field.dataset.capsLockWarn);
				else form.fieldFeedback.set(field.name);
			});
		}
	}

	passwordFields.forEach(function(field) {
		init(field);
	});
};

export default initPasswordChecker;